exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.demo-dynamic[data-v-bccb9d86]{\r\n  background-color: #f6f6f6;\r\n  padding: 15px;\n}\r\n", ""]);

// exports
